import React, { Component } from 'react';
import { isUndefined, map } from 'lodash';
import DataTable from './Datatable';
import moment from 'moment-timezone';
import { DownOutlined } from "@ant-design/icons";
import workOrderStatus from './workOrderStatus.json';
import Loader from '../../../Common/Component/Loader';
import {errorHandle} from "../../../Common/errorHandle";
import chevronDown from "../../../../Assets/images/chevron-down.png";
import StatusOutsideAlerter from '../../../Common/serviceOutsideAlerter';
import { DatePicker, Select, message, Dropdown, Table, Modal, Menu, Checkbox } from 'antd';

const { Option } = Select;
const { RangePicker } = DatePicker;
class WorkOrders extends Component {
  state = {
    loader: false,
    work_orders: [],
    franchise_list: [],
    selected_row_keys: [],
    is_modal_visible: false,
    invoice_date: new moment(),
    set_table_active_action: '',
    customer_types_list: [{name: "Residential"}, {name: "Commercial"}],
    statuses: workOrderStatus.WorkOrderStatus.filter((status) => status.value !== 'all').map((status) => status.value),
    // Filters
    all: 0,
    status: [],
    filters: {},
    franchise: {},
    costumer_type: {},
    status_invoiced: "",
    is_all_selected: false,
    active_pagination: '15',
    toggleStatusFilter: false,
    list_pagination: { current: 1, showSizeChanger: false, pageSize: 15, ordering: "" },
  }

  componentDidMount = () => {
    this.restoreData();
  }

  restoreData = () => {
    const {statuses} = this.state;

    this.clearStatus();
    this.setState({
      loader: true,
      filters:
      {
        scheduled_time__lte: moment().endOf('month').format('YYYY-MM-DD'),
        scheduled_time__gte: moment().startOf('month').format('YYYY-MM-DD'),
        status: statuses.toString()
      }
    });
    
    this.props.getFranchiseList({ offset: 0 });
    this.props.getWorkOrders({
      status: statuses.toString(),
      offset: 0,
      limit: 15,
      scheduled_time__month:moment().format('MM'),
      scheduled_time__year: moment().format('YYYY'),
      // is_exclude_invoiced_wo: true
    });
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    let { 
      filters,
      list_pagination,
      is_all_selected,
      selected_row_keys
    } = this.state;

    //Get franchise list
    if (Object.keys(props.FranchiseList.data).length > 0 
      && props.FranchiseList.data !== this.props.FranchiseList.data) {
      this.setState({
        franchise_list: props.FranchiseList.data.results.sort((a, b) => a.name.localeCompare(b.name)),
        loader: false
      })
    }
    if (Object.keys(props.FranchiseList.errors).length > 0 
      && props.FranchiseList.errors !== this.props.FranchiseList.errors) {
      // display error messsage
      errorHandle(props.FranchiseList.errors)
      this.setState({ loader: false })
    }
    // Get work orders list
    if(Object.keys(props.WorkOrders.data).length > 0 &&
      props.WorkOrders?.data && props.WorkOrders?.data !== this.props.WorkOrders?.data) {
      let filtered_rows = props.WorkOrders?.data.results.filter(
        row => {
          if (row?.status === "complete" || row?.status === "cancelled_billable")
          {
            if (row?.invoice_status !== "Invoiced")
              return true;
          }
          else
          {
            return false;
          }
        }
      );

      if(is_all_selected && selected_row_keys.length === 0)
      {
        let keys = filtered_rows.map(row => row.work_order_uuid);

        this.setState({
          selected_row_keys: keys,
          loader: false,
          all: keys.length
        });
      }
      else
      {
        list_pagination.total = props.WorkOrders?.data.count;
        this.setState({
          work_orders: props.WorkOrders?.data.results,
          list_pagination,
          loader: false,
          all: filtered_rows.length
        });
      }
    }
    else
    {
      this.setState({
        loader: false
      });
    }
    
    if (Object.keys(props.GetGeneratedInvoice.data).length > 0 && 
      props.GetGeneratedInvoice.data !== this.props.GetGeneratedInvoice.data) {
      message.success(props?.GetGeneratedInvoice?.data?.message);
      this.props.getWorkOrders({
        offset: 0,
        limit: 15,
        ...filters,
        // is_exclude_invoiced_wo: true
      });

      this.setState({
        all: 0,
        selected_row_keys: [],
        is_all_selected: false
      });
      this.props.ChangeComponent(0);
      this.props.selectedBatch('process_payments_and_email_invoices');
    }
  }

  // Convert date time from utc to local time
  UTCToLocal = (date) => {
    let stillUtc = moment.utc(date).toDate();
    return moment(stillUtc).local();
  }

   // Set page limit
   setPageLimit = (custom_limit) => {
     let { list_pagination, filters, status } = this.state;
     list_pagination = Object.assign(list_pagination, { 'current': 1, 'pageSize': custom_limit, showSizeChanger: false });

     this.setState({
       list_pagination,
       loader: true,
       active_pagination: custom_limit,
     })

     let data = {
       offset: 0,
       limit: custom_limit,
       ...filters
     }

     Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
     this.props.getWorkOrders({status:status.toString(), ...data})
   }

  //Selct Table Row checkbox
  onSelectedRowKeysChange = (selectedRowKeys) => {
    this.setState({ selected_row_keys: selectedRowKeys });
  }

  onActionChange = (event, action, row) => {
    let { 
      selected_row_keys,
      is_modal_visible
    } = this.state;

    event.preventDefault();

    switch(action)
    {
    case 'send':
      this.onSelectedRowKeysChange([row?.work_order_uuid])
      this.setState({ is_modal_visible: true });
      break;
    case 'costumer':
      if (row?.user) {
        if (row?.user_role === 'customer') {
          this.props.history.push(`/residential/detail`, { query: { id: row.user_uuid } });
        } else if (row?.user_role === 'commercial_customer') {
          this.props.history.push(`/commercial/customer-detail`, { query: { id: row.user_uuid } })
        }
      }
      break;
    case 'work_order':
      if (row?.user) {
        if (row?.user_role === 'customer') {
          this.props.history.push(`/residential/detail?redirect_to_work_order=true`, { query: { 
            id: row.user_uuid, 
            selectedTab: 2,
            service: row.service,
            work_order_uuid: row.work_order_uuid
          }});
        } else if (row?.user_role === 'commercial_customer') {
          this.props.history.push(`/commercial/customer-detail?redirect_to_work_order=true`, { query: {
            id: row.user_uuid,
            selectedTab:  2,
            service: row.service,
            work_order_uuid: row.work_order_uuid
          }})
        }
      }
      break;
    case 'service_order':
      if (row?.user) {
        if (row?.user_role === 'customer') {
          this.props.history.push(`/residential/detail?redirect_to_service=true`, { query: {
            id: row.user_uuid, 
            selectedTab: 2,
            service: row.service,
            work_order_uuid: row.work_order_uuid
          }});
        } else if (row?.user_role === 'commercial_customer') {
          this.props.history.push(`/commercial/customer-detail?redirect_to_service=true`, { query: { 
            id: row.user_uuid,
            selectedTab: 2,
            service: row.service,
            work_order_uuid: row.work_order_uuid
          }});
        }
      }
    }
  }

  // Render table action menu
  renderAction = (record) => {
    const menu = (
      <Menu>
        <Menu.Item
          key="0"
          disabled={((record?.status !== "complete" && record?.status !== "cancelled_billable") || record?.invoice_status === "Invoiced")}
        >
          <a href={'/#'} onClick={(e) => this.onActionChange(e, 'send', record)}>Generate Invoice</a>
        </Menu.Item>
        <Menu.Item key="1"><a href={'/#'} onClick={(e) => this.onActionChange(e, 'costumer', record)}>View Customer</a></Menu.Item>
        <Menu.Item key="2"><a href={'/#'} onClick={(e) => this.onActionChange(e, 'work_order', record)}>View Work Order</a></Menu.Item>
        <Menu.Item key="3"><a href={'/#'} onClick={(e) => this.onActionChange(e, 'service_order', record)}>View Service Order</a></Menu.Item>
      </Menu>
    )

    return (
      <Dropdown overlay={menu} trigger={['hover']}>
        <span onClick={e => e.preventDefault()}>
          <DownOutlined />
        </span>
      </Dropdown>
    )
  }

  toggleStatus = () => {
    const { toggleStatusFilter } = this.state;

    if (toggleStatusFilter) {
      this.setState({ toggleStatusFilter: false });
    } else {
      this.setState({ toggleStatusFilter: true});
    }
  }

  clearStatus = () => {
    workOrderStatus.WorkOrderStatus.forEach(element => {
      element['is_change'] = false;
    });
    this.setState({ status: [], toggleStatusFilter: false }, () => {});
  }

  onStatusChanged = (e, index) => {
    const { status } = this.state;
    let arrStatus = [...status];
    if (e.target.checked) {
      if (index === 0) {
        workOrderStatus.WorkOrderStatus.forEach((element, index) => {
          element['is_change'] = true;
          if (index > 0 && arrStatus.indexOf(element.value) === -1) {
            arrStatus.push(element.value)
          }          
        });
      } else {
        if (arrStatus.indexOf(e.target.id) === -1) {
          workOrderStatus.WorkOrderStatus[index]['is_change'] = true;
          arrStatus.push(e.target.id)
        }
      }      
    } else {
      if (index === 0) {
        workOrderStatus.WorkOrderStatus.forEach(element => {
          element['is_change'] = false;
        });
        arrStatus = []
      } else {
        const ind = arrStatus.indexOf(e.target.id);
        if (ind > -1) {
          workOrderStatus.WorkOrderStatus[0]['is_change'] = false;
          workOrderStatus.WorkOrderStatus[index]['is_change'] = false;
          arrStatus.splice(ind, 1);
        }
      }      
    }
    
    this.setState({ status: arrStatus },() => {
      this.setState({ toggleStatusFilter: false })
      this.onFilter(arrStatus.join(), "status");
    });    
  }

  closeStatusFilter = () => {
    this.setState({ toggleStatusFilter: false })
  }

  renderStatusFilters =  () => {
    const { toggleStatusFilter, status } = this.state;
    return <StatusOutsideAlerter closeServiceOrderFilter={this.closeStatusFilter.bind(this)}>
      <div className="image-input work-order-status">
        <div className="fitem">
          <input 
            type="text" 
            style={{"background":"white", "padding": "5.5px 16px"}}
            id="txtStatus"
            value={status && status.length === 0 ? 'WO Status: All' : `WO Status: ${status.length} items selected`} 
            onFocus={() => {this.toggleStatus() }} 
          />
          <img 
            style={{"top": "0.5px"}}
            src={chevronDown}
            alt=""
            onClick={() => { this.toggleStatus() }} 
          />
        </div>
        {toggleStatusFilter && <div className="field-dropdown right">
          <div className="field-dropdown-body">
            {
              map(workOrderStatus.WorkOrderStatus, (item, index) => {
                return (
                  <div key={index} className="fitem-check">
                    <input
                      id={item.value}
                      type="checkbox"
                      checked={item.is_change}
                      className="fitem-ck-input"
                      onChange={ (e) => { this.onStatusChanged(e, index) } }
                    />
                    <label htmlFor={item.value} className="fitem-ck-txt">{item.label}</label>
                  </div>
                )
              })}
          </div>
        </div>}
      </div>
    </StatusOutsideAlerter>
  }

  onTableFilter = (pagination, filter_filler, sorter) => {
    let { 
      list_pagination, 
      active_pagination,
      filters,
      statuses,
      limit 
    } = this.state;

    let ordering = ''
    if (sorter.column) {
      ordering = sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`
    }
    else {
      ordering = ''
    }

    list_pagination = Object.assign(list_pagination, { 'current': pagination.current, pageSize: active_pagination, showSizeChanger: false });

    if(Object.entries(filters).length === 0 || filters?.status?.length === 0 
      || isUndefined(filters?.status))
    {
      filters = {
        status: statuses.toString(),
        scheduled_time__month:moment().format('MM'),
        scheduled_time__year: moment().format('YYYY')
      }
    }

    this.setState({
      list_pagination,
      loader: true
    })

    let data = {
      // is_exclude_invoiced_wo: true,
      offset: active_pagination * (pagination.current - 1),
      limit: active_pagination,
      ordering,
      ...filters,
    }

    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getWorkOrders(data);
  }

  handleSelectAll = () => {
    const {filters, is_all_selected} = this.state;

    if(!is_all_selected)
    {
      this.setState({
        loader: true,
        is_all_selected: true,
        selected_row_keys: []
      });
      
      this.props.getWorkOrders({
        offset: 0,
        limit: 5000,
        ...filters,
      });
    }
    else
      this.setState({
        selected_row_keys: [],
        is_all_selected: false,
        all: 0
      });
  };

  renderHeaderCheckbox = () => {
    const {is_all_selected} = this.state;

    return <Checkbox
      checked={is_all_selected}
      onChange={this.handleSelectAll}
    />
  }

  //Render Work Orders Table
  renderWorkOrdersTable = () => {
    let { 
      statuses,
      work_orders, 
      list_pagination,
      active_pagination,
      selected_row_keys,
      is_modal_visible
    } = this.state;

    return (
      <React.Fragment>
        <Table
          rowKey={record => record?.work_order_uuid}
          dataSource={work_orders}
          pagination={list_pagination}
          onChange={this.onTableFilter}
          rowSelection={{
            type:'checkbox',
            preserveSelectedRowKeys: true,
            columnTitle: this.renderHeaderCheckbox,
            onSelectAll: this.handleSelectAll,
            selectedRowKeys: selected_row_keys,
            onChange: (selected_row_keys) => {this.onSelectedRowKeysChange(selected_row_keys)},
            getCheckboxProps: (record) => {
              return {
                disabled: (record?.invoice_status === "Invoiced" || (record?.status !== "complete" && record?.status !== "cancelled_billable")),
              }
            },
          }}
          columns={DataTable.AllWorkOrdersList(this)} />
        { 
          work_orders?.length > 0 ?
            <ul className="pagination_page_size">
              <li>
                <span>Show:</span>
              </li>
              <li>
                <span
                  onClick={() => { this.setPageLimit('15') }}
                  className={active_pagination === '15' ? 'active' : ''}
                >
                  15
                </span>
              </li>
              <li>
                <span
                  className={active_pagination === '30' ? 'active' : ''}
                  onClick={() => { this.setPageLimit('30') }}
                >
                  30
                </span>
              </li>
              <li>
                <span
                  className={active_pagination === '60' ? 'active' : ''}
                  onClick={() => { this.setPageLimit('60') }}
                >
                  60
                </span>
              </li>
            </ul> : ''
        }
      </React.Fragment>
    )
  }

  // On date change
  onDateChange = (e) => {
    this.setState({invoice_date: e});
  };

  // On select invoice data and click on send
  onSendInvoice = () => {
    const { selected_row_keys, invoice_date} = this.state;

    this.setState({ is_modal_visible: false });
    console.log(moment(invoice_date).format('YYYY-MM-DD'));
    
    this.props.generateInvoice({
      service_uuids: selected_row_keys.toString(),
      invoice_date: moment(invoice_date).format('YYYY-MM-DD'),
    });
  }

  // On update a filter
  onFilter = (e, type) => {
    let { 
      filters,
      statuses,
      franchise_list,
      list_pagination,
      active_pagination
    } = this.state;
    
    if(e === "" || !e || e === 'all')
    {
      switch(type)
      {
      case "status":
        filters = {...filters, status: statuses.toString()};
        break;
      case "costumer_type":
        filters = {...filters, service_type: ""};
        break;
      case "franchise":
        filters = {...filters, field_office_uuid: ""};
        break;
      case "status_invoiced":
        filters = {...filters, status_invoiced: ""};
      }
    }
    else
    {
      switch(type)
      {
      case "status":
        filters = {...filters, status: e.toString() };
        break;
      case "costumer_type":
        filters = {...filters, service_type: `${e.charAt(0).toLowerCase()}${e.slice(1)}`};
        break;
      case "franchise":
        const franchise = franchise_list?.find((franchise) => franchise.id === parseInt(e));
        filters = {...filters, field_office_uuid: franchise.uuid};
        break;
      case "status_invoiced":
        filters = {...filters, status_invoiced: e }
      }
    }

    this.setState({
      filters,
      loader: true,
      list_pagination: {current: 1, pageSize: active_pagination, showSizeChanger: false}
    })

    let data = {
      // is_exclude_invoiced_wo: true,
      offset: 0,
      limit: active_pagination,
      ...filters
    }

    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getWorkOrders(data);
  }

  //Date Range Change
  onInvoiceDateRange = (e) => {
    let { 
      filters,
      statuses,
      active_pagination
    } = this.state;

    if (e) {
      Object.assign(filters, {
        scheduled_time__month: "",
        scheduled_time__year: "",
        scheduled_time__gte: moment(e[0]).format('YYYY-MM-DD'),
        scheduled_time__lte: moment(e[1]).format('YYYY-MM-DD'),
      });
    }
    else {
      Object.assign(filters, {
        scheduled_time__lte: new moment().endOf('month').format('YYYY-MM-DD'),
        scheduled_time__gte: new moment().startOf('month').format('YYYY-MM-DD'),
        scheduled_time__month:moment().format('MM'),
        scheduled_time__year: moment().format('YYYY'),
      });
    }

    this.setState({filters});

    let data = {
      offset: 0, 
      // is_exclude_invoiced_wo: true,
      limit: active_pagination, 
      ...filters,
    }

    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getWorkOrders(data);
  }
  
  renderSideBar = () => {
    let {
      filters
    } = this.state

    return (
      <aside className="laside">
        <h3>Filters</h3>
        <div className="form-group">
          <div className='fitem'>
            <label>Franchise<sup>*</sup></label>
            <Select
              className=""
              showSearch
              showArrow={true}
              suffixIcon={<i className="las la-angle-down"></i>}
              defaultValue=""
              onChange={(e) => {
                this.setState(s => ({
                  ...s,
                  filters: {...this.filters, franchise: e},
                  franchise: e,
                }));
                this.onFilter(e, "franchise")
              }}
            >
              <Option value="">All</Option>
              {map(this.state.franchise_list, (item) => 
                <Option key={item.id}>{item.name}</Option>
              )}
            </Select>
          </div>
          <div className='fitem'>
            <label>Work Order Date Range<sup>*</sup></label>
            <RangePicker
              format={'MM/DD/YYYY'}
              className=""
              dropdownClassName=""
              suffixIcon={<i className="las la-angle-down"></i>}
              value={filters.scheduled_time__gte && filters.scheduled_time__lte ? [moment(filters.scheduled_time__gte) ? moment(filters.scheduled_time__gte) : undefined, moment(filters.scheduled_time__lte) ? moment(filters.scheduled_time__lte) : undefined] : [null, null]}
              onChange={(e) => { this.onInvoiceDateRange(e) }}
            />
          </div>
        </div>
      </aside>
    );
  }

  // Component Render
  render() {
    let {
      loader,
      filters,
      statuses,
      invoice_date,
      franchise_list,
      is_modal_visible,
      selected_row_keys,
      customer_types_list,
    } = this.state;

    return (
      <React.Fragment>
        <div className="container">
          <div className="aside-area pt-0 account_module_wrapper">
            { this.renderSideBar() }
            <div className="account_expired_card" style={{"flex": "1"}}>
              <ul className="breadcrumb">
                <li onClick={() => { 
                  this.restoreData();
                  this.props.ChangeComponent(0);
                }}
                >
                  <span className="pointer">
                    <i className="las la-angle-left"></i> Back to All Accounts
                  </span>
                </li>
              </ul>
              <Modal
                className=""
                width={400}
                okText={"Generate"}
                cancelText={"Cancel"}
                visible={is_modal_visible}
                onOk={() => this.onSendInvoice()}
                onCancel={() => this.setState({ is_modal_visible: false })}
              >
                <h3 style={{"paddingTop": "25px", "marginBottom": "5px"}}>Generate Draft Invoices</h3>
                <p>{`${selected_row_keys.length} invoices selected.`}</p>
                <div className="fitem">
                  <label>Invoice Date</label>
                  <DatePicker
                    name='invoice_date'
                    format="MM/DD/YYYY"
                    style={{ 'width': '100%' }}
                    value={invoice_date}
                    onChange={(e) => {
                      this.onDateChange(e);
                    }}
                  />
                </div>
              </Modal>
              <h2 style={{ 'padding': '0 25px 0 25px', 'margin': '0' }}>Batch Invoicing</h2>
              <div className="filter_wrapper acc-wrap flex bg-transparent" style={{ padding: '10px 25px 0 25px' }}>
                <div className="right_side">
                  <div className="form-group flex ai-center w-100 flex-end">
                    {this.renderStatusFilters()}
                    <div className='fitem'>
                      <Select
                        showSearch
                        defaultValue=""
                        showArrow={true}
                        className="swhite invoice_status_filter"
                        suffixIcon={<i className="las la-angle-down"></i>}
                        onChange={(e) => {
                          this.setState(s => ({
                            ...s,
                            filters: {...filters, status_invoiced: e},
                            status_invoiced: e,
                          }));
                          this.onFilter(e, "status_invoiced");
                        }}
                      >
                        <Option value="">All</Option>
                        <Option value="invoiced">Invoiced</Option>
                        <Option value="not invoiced">To be invoiced</Option>
                      </Select>
                    </div>
                    <div className="fitem">
                      <Select
                        showSearch
                        defaultValue=""
                        showArrow={true}
                        className="swhite customer_type_filter"
                        suffixIcon={<i className="las la-angle-down"></i>}
                        onChange={(e) => {
                          this.setState(s => ({
                            ...s,
                            filters: {...filters, costumer_type: e},
                            costumer_type: e,
                          }));
                          this.onFilter(e, "costumer_type");
                        }}
                      >
                        <Option value="">All</Option>
                        {map(customer_types_list, (item) => {
                          return (
                            <Option key={item.name}>{item.name}</Option>
                          )
                        })}
                      </Select>
                    </div>
                    <button 
                      disabled={!selected_row_keys.length}
                      style={{"alignSelf": "baseline", "margin": "0px 10px"}}
                      className={`btn ${!selected_row_keys.length ? "btn-disabled": ""}`}
                      onClick={() => this.setState({ is_modal_visible: true })}
                    >
                      Generate Draft Invoices
                    </button>
                  </div>
                </div>
              </div>
              <div className="block-row pt-10">
                {this.renderWorkOrdersTable()}
              </div>
              {loader ? <Loader /> : ''}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default WorkOrders;